module.exports = __webpack_public_path__ + "static/img/banner2.d04aa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner2.png
// module id = 159
// module chunks = 1